<template>
	<div>
		<template v-if="me?.isSuperAdmin()">
			<div class="flex flex-col">
				<SideBarMenuLink :to="'/users'" v-if="me?.hasAdminPermissions()">
					<UsersIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
					<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $tc('User', 2) }}</span>
				</SideBarMenuLink>

				<SideBarMenuLink :to="'/schools'">
					<BuildingOffice2Icon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
					<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $tc('School', 2) }}</span>
				</SideBarMenuLink>
			</div>
		</template>

		<div class="flex flex-col gap-4 pt-4">
			<div class="flex flex-col" v-if="!me?.isSuperAdmin()">
				<SideBarMenuLink :to="{ name: 'lesson-plan-library.my-library' }">
					<RectangleStackIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
					<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $t('Lesson plan library') }}</span>
				</SideBarMenuLink>
			</div>

			<div>
				<!-- School selector trigger -->
				<div class="py-4 border-y border-base-300 flex justify-between items-center"
					:class="[ iconsOnly? 'px-1' : 'px-2', multiOrgUser? 'hover:cursor-pointer hover:bg-base' : '']"
					@click="() => { if(multiOrgUser) { showSchoolSelector = true; } }"
				>
					<div class="flex flex-col uppercase text-xs font-bold overflow-hidden w-full">
						<div v-show="!iconsOnly" class="text-base-content-light">{{ $t('School') }}</div>
						<div v-show="iconsOnly" class="text-accent-content text-2xl text-center">
							{{ currentOrganisation.name.substring(0, 1)}}
						</div>
						<div v-show="!iconsOnly" class="overflow-hidden text-nowrap text-ellipsis text-accent-content">
							{{ currentOrganisation.name }}
						</div>
					</div>
					<div v-if="multiOrgUser" class="flex flex-col" :class="iconsOnly? 'mx-0 w-2' : 'mx-2 w-3'">
						<ChevronUpIcon class="w-full h-3" />
						<ChevronDownIcon class="w-full h-3" />
					</div>
				</div>

				<div class="flex flex-col mt-1" v-if="!me?.isSuperAdmin() && me?.hasAdminPermissions()">
					<SideBarMenuLink :to="'/users'" v-if="me?.hasAdminPermissions()">
						<UsersIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
						<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $tc('User', 2) }}</span>
					</SideBarMenuLink>

					<SideBarMenuLink :to="'/classrooms'" v-if="me?.hasAdminPermissions()">
						<Squares2X2Icon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
						<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $tc('Classroom', 2) }}</span>
					</SideBarMenuLink>

					<SideBarMenuLink to="/pupils" v-if="me?.hasAdminPermissions()">
						<UserGroupIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
						<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $tc('Pupil', 2) }}</span>
					</SideBarMenuLink>

					<SideBarMenuLink
						:to="{ name: 'icon-library.list' }"
						:active="$route.name === 'icon-library.view'"
						v-if="me?.hasAdminPermissions()"
					>
						<!-- <LanguageIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/> -->
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.4" stroke="currentColor" class="w6 h-6 @[10rem]/sidebar:mr-3">
							<path stroke-linecap="round" stroke-linejoin="round" d="M16.5 8.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v8.25A2.25 2.25 0 0 0 6 16.5h2.25m8.25-8.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-7.5A2.25 2.25 0 0 1 8.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 0 0-2.25 2.25v6" transform="scale(1.08) translate(-1, -0.8)"/>
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" transform="scale(0.4) translate(24,25)"/>
						</svg>
						<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $t('Icon library') }}</span>
					</SideBarMenuLink>

					<SideBarMenuLink :to="{name: 'goal-collections'}" v-if="showCurriculumMenuItem">
						<MapPinIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
						<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $t('Grade-level goals') }}</span>
					</SideBarMenuLink>
					<SideBarMenuLink :to="{name: 'school-settings'}">
						<Cog8ToothIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
						<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $t('Settings') }}</span>
					</SideBarMenuLink>
				</div>
			</div>

			<template v-if="!me?.isSuperAdmin()">
				<div v-if="currentClassroom">

					<!-- Classroom selector trigger -->
					<div class="border-base-300 flex justify-between items-center"
						:class="[
							iconsOnly ? 'px-1' : 'px-2',
							classrooms.length > 1 ? 'hover:cursor-pointer hover:bg-base' : '',
							me?.hasAdminPermissions() ? 'py-4 border-y' : 'pt-0 pb-4 border-b'
						]"
						@click="() => { if(classrooms.length > 1) { showClassroomSelector = true; } }"
					>
						<div class="flex flex-col uppercase text-xs font-bold overflow-hidden w-full">
							<div v-show="!iconsOnly" class="text-base-content-light">{{ $t('Classroom') }}</div>
							<div v-show="iconsOnly" class="text-accent-content text-2xl text-center">
								{{ currentClassroom.name.substring(0, 1)}}
							</div>
							<div v-show="!iconsOnly" class="overflow-hidden text-nowrap text-ellipsis text-accent-content">
								{{ currentClassroom.name }}
							</div>
						</div>
						<div v-if="classrooms.length > 1" class="flex flex-col" :class="iconsOnly? 'mx-0 w-2' : 'mx-2 w-3'">
							<ChevronUpIcon class="w-full h-3" />
							<ChevronDownIcon class="w-full h-3" />
						</div>
					</div>

					<div class="flex flex-col mt-1">
						<SideBarMenuLink :to="'/classrooms/' + currentClassroom.id + '/pupils'">
							<UserGroupIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
							<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $tc('Pupil', 2) }}</span>
						</SideBarMenuLink>

						<SideBarMenuLink :to="'/classrooms/' + currentClassroom.id + '/activities'">
							<RectangleGroupIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
							<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $tc('Choice activity', 2) }}</span>
						</SideBarMenuLink>

						<SideBarMenuLink :to="'/classrooms/' + currentClassroom.id + '/agenda'">
							<CalendarDaysIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
							<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $t('Agenda') }}</span>
						</SideBarMenuLink>

						<SideBarMenuLink :to="'/classrooms/' + currentClassroom.id + '/goals'" v-if="showGoalsMenuItem">
							<MapPinIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
							<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $t('Goals & evaluations') }}</span>
						</SideBarMenuLink>

						<SideBarMenuLink :to="'/classrooms/' + currentClassroom.id + '/observations'">
							<EyeIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
							<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $tc('Observation', 2) }}</span>
						</SideBarMenuLink>

						<SideBarMenuLink :to="'/classrooms/' + currentClassroom.id + '/insights'">
							<ChartBarIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
							<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $t('Insights') }}</span>
						</SideBarMenuLink>

						<SideBarMenuLink
							:to="{ name: 'classroom.icon-library.list', params: { classroomId: currentClassroom.id } }"
							:active="$route.name === 'classroom.icon-library.view'"
						>
							<!-- <LanguageIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/> -->
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.4" stroke="currentColor" class="w6 h-6 @[10rem]/sidebar:mr-3">
								<path stroke-linecap="round" stroke-linejoin="round" d="M16.5 8.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v8.25A2.25 2.25 0 0 0 6 16.5h2.25m8.25-8.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-7.5A2.25 2.25 0 0 1 8.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 0 0-2.25 2.25v6" transform="scale(1.08) translate(-1, -0.8)"/>
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" transform="scale(0.4) translate(24,25)"/>
							</svg>
							<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $t('Icon library') }}</span>
						</SideBarMenuLink>

						<SideBarMenuLink :to="{ name: 'classroom.activity-board-setup-info', params: { classroomId: currentClassroom.id } }">
							<ComputerDesktopIcon class="w6 h-6 @[10rem]/sidebar:mr-3"/>
							<span :class="[iconsOnly? 'hidden' : 'ml-3']">{{ $t('Activity & Reflection Board') }}</span>
						</SideBarMenuLink>
					</div>
				</div>

				<div v-else-if="classrooms.length === 0 && !isAdminInCurrentSchool && !iconsOnly" class="text-sm italic px-4">
					{{ $t('#notification: no classroom assigned yet') }}
				</div>
			</template>

		</div>

		<Modal v-if="showSchoolSelector" :modalTitle="$t('Select a school')" :closeOnClickOutside="true" width="md" @requestUnmount="showSchoolSelector = false">
			<template  #default="{ hide }">
				<template v-for="(role, index) in me.roles" :key="index">
					<button type="button"
						class="w-full px-2 py-3 flex justify-between text-left text-xs"
						:class="[ role.organisation === selectedSchool ? 'bg-base-100 border-l-4 border-accent' : role.organisation.active? 'hover:bg-base-100' : 'cursor-not-allowed' ]"
						@click="() => { hide(); changeSchool(role.organisation); }"
					>
						<span class="uppercase">{{ role.organisation.name }}</span>
						<span v-if="!role.organisation.active" class="badge">{{ $t('Inactive') }}</span>
					</button>
				</template>
			</template>
		</Modal>

		<Modal v-if="showClassroomSelector" :modalTitle="$t('Select a classroom')" :closeOnClickOutside="true" width="md" @requestUnmount="showClassroomSelector = false">
			<template  #default="{ hide }">
				<template v-for="(classroom, index) in classrooms" :key="index">
					<button type="button"
						class="w-full px-2 py-3 text-left text-xs"
						:class="[ classroom === selectedClassroom ? 'bg-base-100 border-l-4 border-accent' : 'hover:bg-base-100' ]"
						@click="() => { hide(); changeClassroom(classroom); }"
					>
						<span class="uppercase">{{ classroom.name }}</span>
					</button>
				</template>
			</template>
		</Modal>
	</div>
</template>

<script lang="ts">
import SideBarMenuLink from './SideBarMenuLink.vue'
import {
	HomeIcon,
	UsersIcon,
	UserGroupIcon,
	BuildingOffice2Icon,
	LanguageIcon,
	RectangleGroupIcon,
	Squares2X2Icon,
	EyeIcon,
	ChartBarIcon,
	ComputerDesktopIcon,
	CalendarDaysIcon,
    RectangleStackIcon,
    MapPinIcon,
	ChevronUpIcon,
	ChevronDownIcon,
	Cog8ToothIcon,
} from '@heroicons/vue/24/outline'
import {useClassroomsStore} from "@/stores/Classrooms.store";
import {mapActions, mapState} from "pinia";
import {useOrganisationsStore} from "@/stores/Organisations.store";
import {useUsersStore} from "@/stores/Users.store";
import Modal from '@/components/ui/Modal.vue';
import { Organisation } from '@/models/Organisation.model';
import { Classroom } from '@/models/Classroom.model';

export default {
	name: 'SideBarMenu',
	components: {
		Modal,
		SideBarMenuLink,
		HomeIcon,
		UsersIcon,
		UserGroupIcon,
		BuildingOffice2Icon,
		LanguageIcon,
		RectangleGroupIcon,
		Squares2X2Icon,
		EyeIcon,
		ChartBarIcon,
		ComputerDesktopIcon,
		CalendarDaysIcon,
        RectangleStackIcon,
        MapPinIcon,
		ChevronUpIcon,
		ChevronDownIcon,
		Cog8ToothIcon,
	},
	props: {
		classrooms: {   // should look like [ { id: ..., name: ... }, { ... } ]
			type: Array,
			default: [],
		},
		iconsOnly: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			selectedClassroom: null,
			selectedSchool: null,
			showClassroomSelector: false,
			showSchoolSelector: false,
		};
	},

	created() {
		this.selectedClassroom = this.currentClassroom;
		this.selectedSchool = this.currentOrganisation;
	},

	computed: {
		...mapState(useClassroomsStore, ['currentClassroom']),
		...mapState(useOrganisationsStore, ['currentOrganisation']),
		...mapState(useUsersStore, ['me']),

		multiOrgUser() {
			return this.me.roles.length > 1;
		},

		showCurriculumMenuItem(): boolean {
			if (
				this.currentOrganisation.curriculum &&
				this.isAdminInCurrentSchool
			) {
				return true;
			}

			return false;
		},

		showGoalsMenuItem(): boolean {
			if (this.currentOrganisation.curriculum) {
				return true;
			}

			return false;
		},

		isAdminInCurrentSchool(): boolean {
			return this.me.roles.some(
				role => role.organisation.id === this.currentOrganisation.id && role.hasAdminPermissions());
		}
	},

	methods: {
		...mapActions(useClassroomsStore, [ 'switchClassroom' ]),
		...mapActions(useOrganisationsStore, ['switchToOrganisation']),

		changeSchool(school: Organisation) {
			this.showSchoolSelector = false;
			if (!school.active || this.selectedSchool === school) {
				return;
			}
			this.selectedSchool = school;

			this.switchToOrganisation(school);
		},

		changeClassroom(classroom: Classroom) {
			this.showClassroomSelector = false;
			if (this.selectedClassroom === classroom) {
				return;
			}
			this.selectedClassroom = classroom;
			this.switchClassroom(classroom);
			//window.location.reload();
		}
	}
}
</script>
